import React from "react";
import "../CSS/BookmarkPage.css";

const BookmarkPage = () => {
  const chromeStoreUrl = "https://chromewebstore.google.com/detail/threadshare/mkdemnaiienmhffacabkpboljfcdmfel";
  const safariStoreUrl = "https://apps.apple.com/us/app/threadshare-for-safari/id6757684487?mt=12";

  return (
    <div className="bookmark-page-container">
      <header className="bookmark-page-header">
        <h1 className="bookmark-page-title">Browser Extension</h1>
        <p className="bookmark-page-subtitle">
          Save and share your AI conversations from ChatGPT, Claude, and Gemini with one click
        </p>
      </header>
      
      <div className="bookmark-page-content">
        {/* Download Section */}
        <section className="bookmark-section">
          <div className="extension-download-cards">
            {/* Chrome Card */}
            <a 
              href={chromeStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="extension-card extension-card-chrome"
            >
              <div className="extension-card-icon">
                <svg viewBox="0 0 24 24" width="48" height="48">
                  <circle cx="12" cy="12" r="10" fill="#4285F4"/>
                  <circle cx="12" cy="12" r="4" fill="white"/>
                  <path d="M12 2a10 10 0 0 1 8.66 5H12V2z" fill="#EA4335"/>
                  <path d="M20.66 7A10 10 0 0 1 12 22V12l8.66-5z" fill="#34A853"/>
                  <path d="M12 22a10 10 0 0 1-8.66-15L12 12v10z" fill="#FBBC05"/>
                </svg>
              </div>
              <div className="extension-card-content">
                <h3>Chrome Extension</h3>
                <p>For Google Chrome, Brave, Edge & other Chromium browsers</p>
                <span className="extension-card-button">Add to Chrome →</span>
              </div>
            </a>

            {/* Safari Card */}
            <a 
              href={safariStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="extension-card extension-card-safari"
            >
              <div className="extension-card-icon">
                <svg viewBox="0 0 24 24" width="48" height="48">
                  <circle cx="12" cy="12" r="11" fill="linear-gradient(180deg, #5AC8FA 0%, #007AFF 100%)"/>
                  <circle cx="12" cy="12" r="10" fill="url(#safariGradient)"/>
                  <defs>
                    <linearGradient id="safariGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                      <stop offset="0%" stopColor="#5AC8FA"/>
                      <stop offset="100%" stopColor="#007AFF"/>
                    </linearGradient>
                  </defs>
                  <circle cx="12" cy="12" r="8" fill="none" stroke="white" strokeWidth="0.5" opacity="0.5"/>
                  <line x1="12" y1="4" x2="12" y2="6" stroke="white" strokeWidth="1"/>
                  <line x1="12" y1="18" x2="12" y2="20" stroke="white" strokeWidth="1"/>
                  <line x1="4" y1="12" x2="6" y2="12" stroke="white" strokeWidth="1"/>
                  <line x1="18" y1="12" x2="20" y2="12" stroke="white" strokeWidth="1"/>
                  <polygon points="12,5 13,12 12,13 11,12" fill="#FF3B30"/>
                  <polygon points="12,19 11,12 12,11 13,12" fill="white"/>
                </svg>
              </div>
              <div className="extension-card-content">
                <h3>Safari Extension</h3>
                <p>For Safari on macOS</p>
                <span className="extension-card-button">Get on App Store →</span>
              </div>
            </a>
          </div>
        </section>

        <section className="bookmark-section">
          <div className="important-banner">
            <strong>IMPORTANT:</strong> Please install the browser extension to start saving your AI conversations.
          </div>
        </section>

        <section className="bookmark-section">
          <h2>Getting Started</h2>
          <p>
            With our browser extension, you can easily save AI conversations and conveniently access them. 
            There are multiple ways to use the ThreadShare extension in your browser:
          </p>
        </section>

        <section className="bookmark-section">
          <h2>Toolbar Button</h2>
          <p>
            Click the ThreadShare icon in your browser's toolbar to open the extension popup. From there, you can:
          </p>
          <ul>
            <li>Sign in with your ThreadShare account or use Google OAuth</li>
            <li>Save the current conversation from ChatGPT, Claude, or Gemini</li>
            <li>View your recently saved conversations</li>
            <li>Access your ThreadShare dashboard</li>
          </ul>
          <p className="bookmark-note">
            <strong>Note:</strong> If you cannot locate the ThreadShare toolbar button, click on the "puzzle" icon 
            (extensions menu) first and then pin it for easy access.
          </p>
        </section>

        <section className="bookmark-section">
          <h2>Floating Button</h2>
          <p>
            When you're on a supported AI platform (ChatGPT, Claude, or Gemini), a floating button will appear 
            in the bottom-right corner of the page. Click it to quickly save the current conversation.
          </p>
        </section>

        <section className="bookmark-section">
          <h2>How to Save Conversations</h2>
          
          <div className="bookmark-step">
            <h3>Save Page</h3>
            <ol>
              <li>Browse to a ChatGPT, Claude, or Gemini conversation page</li>
              <li>Click the extension button in your toolbar or the floating button on the page</li>
              <li>Click "Save Current Conversation" to save it to your ThreadShare account</li>
              <li>Your conversation is instantly saved and accessible on ThreadShare.ai</li>
            </ol>
          </div>

          <div className="bookmark-step">
            <h3>Supported Platforms</h3>
            <ul>
              <li><strong>ChatGPT:</strong> chatgpt.com and chat.openai.com</li>
              <li><strong>Claude:</strong> claude.ai</li>
              <li><strong>Google Gemini:</strong> gemini.google.com</li>
            </ul>
          </div>
        </section>

        <section className="bookmark-section">
          <h2>Features</h2>
          <ul>
            <li>One-click conversation saving</li>
            <li>Support for ChatGPT, Claude, and Gemini</li>
            <li>Quick access to your most recent saved conversations</li>
            <li>Share conversations via ThreadShare dashboard</li>
            <li>Beautiful dark mode interface</li>
            <li>Secure authentication via Google OAuth</li>
            <li>Access conversations from any device</li>
          </ul>
        </section>

        <section className="bookmark-section">
          <h2>Installation</h2>
          <p>
            ThreadShare is available for both Chrome and Safari browsers. Choose your browser below:
          </p>
          
          <div className="bookmark-step">
            <h3>🌐 Google Chrome / Chromium Browsers</h3>
            <ol>
              <li>Visit the <a href={chromeStoreUrl} target="_blank" rel="noopener noreferrer">Chrome Web Store</a></li>
              <li>Click "Add to Chrome"</li>
              <li>Confirm the installation</li>
              <li>Pin the extension to your toolbar for easy access</li>
              <li>Start saving your AI conversations!</li>
            </ol>
            <p className="bookmark-note">
              <strong>Note:</strong> Also works on Brave, Microsoft Edge, Opera, and other Chromium-based browsers.
            </p>
          </div>

          <div className="bookmark-step">
            <h3>🧭 Safari (macOS)</h3>
            <ol>
              <li>Visit the <a href={safariStoreUrl} target="_blank" rel="noopener noreferrer">Mac App Store</a></li>
              <li>Click "Get" to download ThreadShare for Safari</li>
              <li>Open Safari and go to Safari → Settings → Extensions</li>
              <li>Enable the ThreadShare extension</li>
              <li>Start saving your AI conversations!</li>
            </ol>
            <p className="bookmark-note">
              <strong>Note:</strong> Safari extensions are distributed through the Mac App Store for security.
            </p>
          </div>
        </section>

        <section className="bookmark-section">
          <h2>Tips & Tricks</h2>
          
          <div className="bookmark-tip">
            <h3>One-Click Save</h3>
            <p>
              The fastest way to save a conversation is using the floating button that appears on AI platform pages. 
              No need to open the extension popup—just click and save!
            </p>
          </div>

          <div className="bookmark-tip">
            <h3>Recent Conversations</h3>
            <p>
              The extension popup shows your 5 most recently saved conversations for quick access. Click any 
              conversation to open it in your ThreadShare dashboard.
            </p>
          </div>

        </section>

        <section className="bookmark-section">
          <h2>Troubleshooting</h2>
          
          <div className="bookmark-faq">
            <h3>Extension button not showing</h3>
            <p>
              Click the puzzle icon in your browser toolbar, find ThreadShare, and click the pin icon to 
              keep it visible in your toolbar.
            </p>
          </div>

          <div className="bookmark-faq">
            <h3>Floating button not appearing</h3>
            <p>
              Make sure you're on a supported platform (ChatGPT, Claude, or Gemini). Try refreshing the page. 
              If it still doesn't appear, check the browser console for errors.
            </p>
          </div>

          <div className="bookmark-faq">
            <h3>Conversation not saving</h3>
            <p>
              Verify you're on a supported platform and that the conversation page has fully loaded. Check 
              your browser console for any error messages. If you're signed in, make sure your authentication 
              is still valid.
            </p>
          </div>

          <div className="bookmark-faq">
            <h3>What data does the extension collect?</h3>
            <p>
              The extension only accesses conversation content from ChatGPT, Claude, and Gemini pages when you 
              explicitly click "Save Current Conversation." We do not collect data from any other websites or 
              track your browsing activity. All saved conversations are stored securely and only accessible 
              through your authenticated account. For more details, see our{" "}
              <a href="/privacy-policy">Privacy Policy</a>.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default BookmarkPage;

